var xP = require('../xP')
  , $ = require('jquery');

module.exports = {
  name: 'select', base: '_field', prototype: {
    element_selector: 'select',

    hide_disabled_option: true,

    init: function (params) {
      xP.controls.select.base.init.apply(this, arguments);

      this._.options = this.$element[0].options;

      this._.all_options = xP.list(this._.all_options);
      this._.enabled_options = xP.list(this._.enabled_options);

      var options = this.$element[0].options, i = 0, ii = options.length;

      for (; i < ii; i++) {
        this._.all_options.append(options[i]);
      }
    },

    append: function (params) {
      if ($.type(params) !== 'array') {
        params = [params];
      }

      var all_options = this._.all_options, options = this._.options,
        i = 0, ii = params.length;

      for (; i < ii; i++) {
        all_options.push(
          options[options.length] = $.type(params[i]) === 'array'
            ? new Option(params[i][0], params[i][1])
            : (
            $.type(params[i]) !== 'object'
              ? new Option(params[i])
              : (
              params[i] instanceof Option
                ? params[i]
                : new Option(params[i].label, params[i].value)
            )
          )
        );
      }

      return this;
    },

    remove: function () {
      this._.options.length = 0;
      this._.all_options.length = 0;

      return this;
    },

    disable: function (disabled, dependence) {
      if (dependence && dependence.values !== undefined) {
        // TODO: Добавить поддержку optgroup.
        var that = this, values = dependence.values,
          i, ii = values.length;

        this._.all_options.each(function () {
          var disable = true;

          if (!disabled) {
            for (i = 0; i < ii; i++) {
              if ($.type(values[i]) === 'regexp') {
                disable = !this.value.match(values[i]);
              } else {
                disable = this.value != values[i];
              }

              if (!disable) {
                that._.enabled_options.append(this);

                break;
              }
            }
          }

          if (disable) {
            this.disabled = 'true';
          }
        });

        clearTimeout(this._.enable_options);

        this._.enable_options = xP.after(function () {

          var options = that._.options;

          if (that.hide_disabled_option) {
            options.length = 0;

            that._.enabled_options.each(function (i) {
              this.disabled = '';

              if (!this.parentNode) {
                options[options.length] = this;
              }
            });
          } else {
            that._.enabled_options.each(function (i) {
              this.disabled = '';
            });

            var selected = that.$element[0].selectedIndex;

            if (!options[selected] || options[selected].disabled) {
              that.$element[0].selectedIndex =
                that._.all_options.index(
                  that._.enabled_options.first()
                );
            }
          }

          that.change();

          that._.enabled_options.length = 0;
        });

        return this;
      } else {
        return xP.controls.select.base.disable.apply(this, arguments);
      }
    },

    val: function (value) {
      if (!arguments.length) {
        return this.disabled ? undefined : this.$element.val();
      } else {
        if (this.$element[0].value != value) {
          this.$element.val(value);

          this.change();
        }

        return this;
      }
    },

    change: function (handler, remove) {
      if (!arguments.length) {
        var $element = this.$element[0],
          selected = $element.selectedIndex;

        this.$selected = $($element.options[selected]);
      }

      return xP.controls.select.base.change.apply(this, arguments);
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/select.js
 ** module id = 34
 ** module chunks = 0
 **/